import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import Routes from './routes';
import registerServiceWorker from './registerServiceWorker';
import axios from 'axios';

if (process.env.NODE_ENV === 'production') {
    // eslint-disable-next-line no-undef
    Raven.config('https://d4484851fa2440d2b79a65ec410fe815@sentry.io/215967').install();
}

axios.defaults.baseURL = process.env.REACT_APP_PLATFORM_ENVIROMENT;
axios.defaults.headers.common['Authorization'] = `Bearer ${process.env.REACT_APP_PLATFORM_ACCESS_TOKEN}`;

ReactDOM.render(
    <Routes />,
    document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js